"use client";

import { House } from "lucide-react";
import Link from "next/link";

export default function NotFound() {
  return (
    <div className="flex min-h-[70vh] p-5 m-0 w-full items-center justify-center flex-col gap-6">
      <div className="mc-panel mc-grass-top p-8 text-center max-w-md">
        <h2 className="text-2xl text-primary mb-3 uppercase">404 — Chunk Not Loaded</h2>
        <p className="text-card-foreground mb-6">
          You wandered past the world border. This block doesn&apos;t exist yet.
        </p>
        <Link href="/" className="mc-btn inline-flex items-center justify-center gap-2 px-4 py-3 uppercase">
          <House size={16} /> Respawn at Home
        </Link>
      </div>
    </div>
  );
}
